import { ResourceOperations, ResourceTypes } from '../../../authentication/resources';
import { communicationTabLabel, communicationTabPathName } from '../../../areas/citizen/authority/citizen-authority-area-pathnames';
import { omnibarActionParam, ServiceProviderOmnibarAction } from '../../../areas/citizen/serviceprovider/hooks/use-omnibar-action';
import { OmnibarEntry } from '../omnibar-interfaces';
import { catalogCorrectionsToggle } from '../utils/catalog-corrections';

const tabUrl = `/deeplink/citizen/:contextId/${communicationTabPathName}`;

function tabActionUrl(action: ServiceProviderOmnibarAction) {
  return `${tabUrl}?${omnibarActionParam}=${action}`;
}

const functions: OmnibarEntry[] = [
  {
    id: '6b1e9d4a-3c7f-4a2b-8e5d-f0c3a9b7e214',
    label: communicationTabLabel,
    keywords: ['besked', 'udbakke', 'spørgeskema', 'forum'],
    context: 'citizen',
    group: 'Borgerområde',
    url: tabUrl,
    hideForAnonymousCitizen: true,
    featureToggleRequired: catalogCorrectionsToggle,
  },
  {
    id: 'c9e3a7f1-5b2d-4e8c-a6f4-2d8b1e7c9a53',
    label: 'Opret besked i Forum',
    keywords: ['kommunikation', 'borgerdialog', 'chat'],
    context: 'citizen',
    group: 'Borgerhandling',
    url: tabActionUrl(ServiceProviderOmnibarAction.CreateForumChat),
    resourceActions: [{ resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.CitizenDialog }],
    hideForAnonymousCitizen: true,
    featureToggleRequired: [catalogCorrectionsToggle, 'EnableSagWebApex'],
  },
  {
    id: '2f8d6b3e-9a1c-4d7f-b5e2-8c4a0f6d1b97',
    label: 'Opret spørgeskema',
    keywords: ['kommunikation', 'screening'],
    context: 'citizen',
    group: 'Borgerhandling',
    url: tabActionUrl(ServiceProviderOmnibarAction.CreateSurvey),
    tenantAddonEnabled: ['Screening_Custom', 'Screening_SelfServiceGuidance'],
    hideForAnonymousCitizen: true,
    featureToggleRequired: catalogCorrectionsToggle,
  },
];

export default functions;
